"use client";

import { useUser } from "@/components/clients/LocaleToStorage";
import RouterLink from "@/components/ui/router-link";
import { useScopedI18n } from "@/messages/client";
import { usePathname } from "next/navigation";
import { useMemo } from "react";
import useSWR from "swr";

export default function Datasheet(props: {
  datasheet?: (string | null | undefined)[];
  datasheetTexts?: (string | null | undefined)[];
  name: string;
}) {
  const t = useScopedI18n("产品");

  const pathname = usePathname();

  const { user } = useUser();

  const currentFile = useMemo(() => {
    const level = user?.role?.level;
    if (level) {
      return props.datasheet?.[level - 1];
    }
  }, [user, props.datasheet]);

  const currentFileName = useMemo(() => {
    const level = user?.role?.level;
    if (level) {
      return props.datasheetTexts?.[level - 1];
    }
  }, [user, props.datasheetTexts]);

  const { data } = useSWR<{
    data: {
      id: string;
      filename_download: string;
      title: string;
      type: string;
      uploaded_on: string;
    };
  }>(
    () =>
      currentFile
        ? `${process.env.NEXT_PUBLIC_API_HOST}/files/${currentFile}`
        : null,
    async (url: string) => {
      return fetch(url).then((res) => res.json());
    }
  );

  if (!data?.data) {
    return null;
  }

  if (!user) {
    return (
      <RouterLink
        href={`/login?redirect_url=${pathname}`}
        className="flex shrink-0 items-center space-x-2">
        <img className="h-5 w-5" src="/icons/pdf.svg" alt="DataSheet File" />

        <div className="text-sm text-[#FF5100] lg:text-base">
          {t("下载数据表")}
        </div>
      </RouterLink>
    );
  }

  return (
    <a
      target="_blank"
      download
      href={`${process.env.NEXT_PUBLIC_DIRECTUS_ASSETS}/${data.data?.id}/${data.data?.filename_download}`}
      className="flex shrink-0 items-center space-x-2">
      <img className="h-5 w-5" src="/icons/pdf.svg" alt="DataSheet File" />

      <div className="text-sm text-[#FF5100] lg:text-base">
        {currentFileName ? t<any, any>("下载{name}", { name: currentFileName }) : t("下载数据表")}
      </div>
    </a>
  );
}
